const styles = `:host {
  border-right-width: 1px;
  border-right-style: solid;
  border-right-color: var(--goto-navigation-rail-border-right);
  display: flex;
  flex-direction: column;
  background-color: var(--goto-navigation-rail-background);
  padding: 8px 0;
  width: 72px;
  box-sizing: border-box;
}
:host ::slotted(chameleon-menu-separator) {
  flex-grow: 1;
  border-color: transparent;
}

:host([size=small]) {
  width: 56px;
}

:host([size=large]) {
  width: 164px;
}`; export default styles;